import gql from 'graphql-tag'

export const formasLeitura = gql`query {
  formasLeitura(page: {}) {
    id
    nome
    unidadeMedida
  }
}`

export const leituras = gql`query ($formaLeitura: Int!, $referencia: String!, $offset: Int!){
  leituras(filter: { formaLeitura: $formaLeitura, referencia: $referencia }, page: { offset: $offset }) {
    id
    data
    valor
    valorCobrado
    unidade {
      id
      nome
      tipo
    }
  }
}`
